module.exports = __webpack_public_path__ + "static/media/io.a77fd289.svg";